import styled from 'styled-components'

export default styled.div`
  display: flex;
  flex-direction: row;
  gap: 8px;
  margin: 8px 0px;
  align-items: center;

  @media screen and (max-width: 768px) {
    margin: 0 0 8px;
  }

  .search-container {
    width: 100%;
    position: relative;
    display: flex;

    .search-icon {
      position: absolute;
      top: 2px;
      z-index: 1;
      padding: 10px;
      img {
        filter: brightness(0);
      }
    }
  }

  .buttons-container {
    padding: 7px;
    cursor: pointer;
    position: absolute;
    top: 2px;
    right: 2px;
    display: flex;
    flex-direction: row;
    gap: 16px;

    img {
      width: 25px;
      height: 25px;
    }
  }
`
